import { Fragment, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { useNavigate } from 'react-router'
import { positionDropdown } from '../../../../common/dropdown'
import { Element } from '../../../../common/html/element'
import { Icon } from '../../../../common/html/icon'
import StatusTag, { STATUS_COLOR } from '../../../../common/statusTag'
import { Tooltip } from '../../../../common/tooltip'
import EventEmitter, {
  CHANGE_COMPANY_HEADER,
} from '../../../../helpers/EventEmitter'
import { selectUserType } from '../../../../layout/store/slice'
import { COMPONENTS } from '../../../../routers/constants'
import { USER_TYPE } from '../../../../utils/authorization'
import {
  LIST_LOCATION_TYPE,
  LOCATION_COLOR,
  RESULT_KEY_INFO,
} from '../constants'
import classes from '../index.module.scss'

const COLOR_NOT_VIEW_ALLOW = '#9c9c9c'
const BG_COLOR_STATUS_NOT_VIEW_ALLOW = '#e0e0e0'
const BG_COLOR_HEAD_NOT_VIEW_ALLOW = '#e0e0e0'

export const SearchResultItem = ({ data }) => {
  const navigate = useNavigate()

  // Use selector
  const userType = useSelector(selectUserType)

  // Use state
  const [isHover, setIsHover] = useState(false)

  // Get data
  const getItemBgColor = useMemo(() => {
    return isHover ? '#F3F3F3' : '#fff'
  }, [isHover])

  // Actions
  const onMouseEnter = () => {
    if (data.viewAllowed) {
      setIsHover(true)
    }
  }

  const onMouseLeave = () => {
    setIsHover(false)
  }

  const onClickItem = () => {
    if (data.viewAllowed) {
      if (
        [USER_TYPE.PREMIUM, USER_TYPE.STANDARD, USER_TYPE.TRIAL].includes(
          userType.userTypeId,
        ) ||
        (userType.userTypeId === USER_TYPE.LITE && data?.viewLiteFree)
      ) {
        EventEmitter.dispatch(CHANGE_COMPANY_HEADER)
        navigate(
          `${COMPONENTS.companyAnalysis.components.summary.route}?organizationId=${data.organizationId}`,
        )
      } else {
        navigate(
          `${COMPONENTS.domesticSearch.components.domesticSearchPreview.route}?organizationId=${data.organizationId}`,
        )
      }
    }
  }

  return (
    <Element
      elementName="div"
      style={{ backgroundColor: getItemBgColor, fontSize: 10 }}
      className={['py1 px2 cursorPointer', classes.searchResultItem].join(' ')}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={onClickItem}
    >
      <div className="dFlex">
        <div className="w100 fw400">
          <Element
            elementName="div"
            style={{
              color: data.viewAllowed ? '#191D25' : COLOR_NOT_VIEW_ALLOW,
            }}
            className="fw600 textUppercase"
          >
            {data.organizationName}
          </Element>
          <div className="dFlex alignItemsCenter">
            <StatusTag
              status={data.activeStatusId}
              label={data.activeStatusName}
              style={{
                color: '#fff',
                backgroundColor: data.viewAllowed
                  ? STATUS_COLOR[data.activeStatusId]
                  : BG_COLOR_STATUS_NOT_VIEW_ALLOW,
                padding: '2px 4px',
                margin: '8px 4px 4px 0px',
              }}
            />
            {data.isHeadQuarters && (
              <Element
                elementName="div"
                className={classes.tagStatus}
                style={{
                  color: data.viewAllowed ? '#000' : COLOR_NOT_VIEW_ALLOW,
                  backgroundColor: data.viewAllowed
                    ? LOCATION_COLOR[LIST_LOCATION_TYPE.HEADQUARTERS]
                    : BG_COLOR_HEAD_NOT_VIEW_ALLOW,
                }}
              >
                <Translate value="domesticSearch.HEADQUARTERS" />
              </Element>
            )}
          </div>
          <div className={classes.itemInfo}>
            {Object.keys(RESULT_KEY_INFO).map((key) => (
              <Fragment key={key}>
                <Element
                  elementName="span"
                  style={{
                    color: data.viewAllowed ? '#3A414B' : COLOR_NOT_VIEW_ALLOW,
                  }}
                  className="fw600"
                >
                  <Translate value={'domesticSearch.' + key} />:
                </Element>
                <Element
                  elementName="span"
                  style={{
                    color: data.viewAllowed ? '#3A414B' : COLOR_NOT_VIEW_ALLOW,
                  }}
                >
                  {data[RESULT_KEY_INFO[key]]}
                </Element>
              </Fragment>
            ))}
          </div>
        </div>

        <div>
          <div className="dFlex alignItemsCenter">
            {!data.viewAllowed && (
              <Icon
                className="icon-lock"
                style={{
                  fontSize: 16,
                  marginRight: 4,
                }}
              />
            )}
            {!!data.numberOfPortfolios && (
              <Tooltip
                tooltipContent={
                  <div className="flexColumn">
                    {data.portfolios &&
                      data.portfolios.map((val, index) => (
                        <div key={index}>{val}</div>
                      ))}
                  </div>
                }
                position={positionDropdown.LEFT_CENTER}
              >
                <div className="dFlex alignItemsCenter">
                  <Icon
                    className="icon-folder"
                    style={{
                      fontSize: 16,
                      color: data.viewAllowed ? '#ffde86' : '#d5d5d5',
                    }}
                  />
                  <Element
                    elementName="span"
                    style={{
                      marginLeft: 4,
                      color: data.viewAllowed ? '' : COLOR_NOT_VIEW_ALLOW,
                    }}
                  >
                    {data.numberOfPortfolios}
                  </Element>
                </div>
              </Tooltip>
            )}
          </div>
        </div>
      </div>

      <div className={classes.divider}></div>
    </Element>
  )
}
